module.exports = __webpack_public_path__ + "img/CENTRIFUGADORAS_VERTICALES_SALA.4053114c.jpg";